module.exports = __webpack_public_path__ + "static/media/promo.9405a61e.png";